import { useGenericAppStore } from '#ui-shared/stores/generic-app-store';

// Feed browser connectivity into the app state. Seed from navigator.onLine (the offline event
// only fires on a transition, so a cold offline start would be missed), then track online/offline.
// This is the default connectivity source; in webview the native layer's CONNECTIVITY_CHANGED
// takes over once it arrives (see setNetworkOnline in generic-app-store).
export function bootstrapConnectivity(): void {
  const appStore = useGenericAppStore();

  appStore.setNetworkOnline(navigator.onLine);

  window.addEventListener('online', () => {
    appStore.setNetworkOnline(true);
  });

  window.addEventListener('offline', () => {
    appStore.setNetworkOnline(false);
  });
}
